import { faUserGear, faUserMinus, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { type FC, memo } from 'react';

import type { Props } from '@/components/TreatmentGroupEnrollmentButton/types';
import { Button } from '@/ui';

const TreatmentGroupEnrollmentButton: FC<Props> = ({
  isEnrolled,
  isPending,
  manageMode,
  onEnroll,
  onRemove
}) => {
  if (isEnrolled && manageMode) {
    return (
      <Button
        color="neutral"
        isLoading={isPending}
        leftIcon={faUserGear}
        onClick={onRemove}
        size="sm"
        variant="outline">
        Manage
      </Button>
    );
  }

  if (isEnrolled) {
    return (
      <Button
        color="destructive"
        isLoading={isPending}
        leftIcon={faUserMinus}
        onClick={onRemove}
        size="sm"
        variant="outline">
        Remove from group
      </Button>
    );
  }

  return (
    <Button
      color="primary"
      isLoading={isPending}
      leftIcon={faUserPlus}
      onClick={onEnroll}
      size="sm">
      Add to Group
    </Button>
  );
};

export default memo(TreatmentGroupEnrollmentButton);
